import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, Text } from 'trpc-react-native-ui';
import I18n from '../../../lib/i18n';
import theme from '../../../theme-config';
import { DateTimeLabel, Icon } from '../../common';
import { getPaymentLabelFromPaidItems, getProductFromNameOrType } from '../lib/PaymentLabelService';
import { NavigationRoute, NavigationScreenProp } from '@react-navigation/compat';
import formatAmount from '../../../lib/formatAmount';

const styles = StyleSheet.create({
  arrowStyle: {
    color: theme.contracts.arrowColor,
  },
  parentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingVertical: 16,
  },
  leftContainer: {
    display: 'flex',
    justifyContent: 'center',
    flex: 5,
  },
  rightContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    flex: 1,
  },
  dateLabel: {
    color: theme.gray.normal,
    fontSize: 13,
    lineHeight: 22,
  },
  text: {
    fontSize: 13,
    fontWeight: '500',
  },
  separator: {
    borderBottomColor: theme.gray.light,
    borderBottomWidth: 1,
    marginHorizontal: 20,
  },
});

type Props = {
  amount: number,
  navigation: NavigationScreenProp<NavigationRoute>,
  paidItems: Object[],
  paymentId: string,
  paymentMeanCharacteristics: ?Object,
  paymentMeanOuid?: string,
  paymentMeanType?: string,
  status?: string,
  timestamp: number,
  transactionId: string,
};

const PaymentListViewRow = ({
  amount,
  navigation,
  paidItems,
  paymentId,
  paymentMeanCharacteristics,
  paymentMeanType,
  status,
  timestamp,
  transactionId,
}: Props) => {
  const filteredPaidItems = paidItems.filter(
    paidItem => getProductFromNameOrType(paidItem.name, paidItem.type)?.shouldBeDisplayedOnPayment
  );

  const isDropped = status === 'REJECTED' || status === 'CANCELLED';
  const paymentLabel = getPaymentLabelFromPaidItems(filteredPaidItems);
  const price = formatAmount(amount);

  const goToPaymentDetails = () =>
    navigation.navigate('paymentDetails', {
      paidItems: filteredPaidItems,
      paymentMeanCharacteristics: paymentMeanCharacteristics,
      paymentMeanType: paymentMeanType,
      price: amount,
      timestamp: timestamp,
      transactionId: transactionId,
      paymentId: paymentId,
    });

  return (
    <Button disabled={isDropped} onPress={goToPaymentDetails}>
      <View style={styles.parentContainer}>
        <View style={styles.leftContainer}>
          <DateTimeLabel timestamp={timestamp} style={styles.dateLabel} />
          <Text style={styles.text}>{isDropped ? I18n.t('rejectedPayment') : paymentLabel}</Text>
        </View>
        <View style={styles.rightContainer}>
          <Text style={styles.text}>{price}</Text>
          {!isDropped && <Icon name="arrow-right" size={18} style={styles.arrowStyle} />}
        </View>
      </View>
      <View style={styles.separator} />
    </Button>
  );
};

export default PaymentListViewRow;
